export default __webpack_public_path__ + "static/media/map.e7ab1205.svg";